<div class="reservation-pannel">
  <div class="row">
    @if (selectedIndex === additonalGuestIndex) {
      <div class="col-lg-9 col-md-9">
        <!-- <app-activity-guest-edit></app-activity-guest-edit> -->
        <ng-container #comp *ngComponentOutlet="currentComponent"></ng-container>
      </div>
    }
  </div>
</div>